import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { CustomCellProps } from 'components/common/grid/';
import IconMi from 'components/common/icon/IconMi';
import GenerateAlertEventsButton from 'app/report/report-alert-rule/GenerateAlertEventsButton';
import useBundleTranslation from 'i18n';

export default function GenerateReportAlertsCell({
    elementId,
    alertRuleId,
}: CustomCellProps & { elementId: number; alertRuleId: number }) {
    const { t } = useBundleTranslation(['app/report/report-alert-rule']);

    return (
        <GenerateAlertEventsButton elementId={elementId} alertRuleId={alertRuleId}>
            <Tooltip title={t('regenerate_alert_events')}>
                <IconButton size={'small'} sx={{ color: 'text.primary' }}>
                    <IconMi icon={'refresh-cw'} fontSize={'16'} />
                </IconButton>
            </Tooltip>
        </GenerateAlertEventsButton>
    );
}
